export default __webpack_public_path__ + "static/media/pdf.3e67dc20.svg";